<style scoped>
</style>

<template>
  <section class="container">
    <iframe style="width:100%; height:460px;" id="catalogo" :src="link"
            frameborder="0" allowfullscreen>
    </iframe>
    <!--<img src="../../assets/images/print_tela_catalogo_virtual.png"/>-->
  </section>
</template>

<script>
  export default {
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/catalogo_virtual').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    computed: {
      link () {
        return this.$store.state.parametros.LINK_CATALOGO_VIRTUAL
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/download/DetalheCatalogoVirtual.vue